import React from "react";

export default function StarEspeciality() {
  const star = require("../Images/icons8-star-32.png");
  return (
    <img src={star} style={{ width: 23, height: 23, cursor: "pointer" }} />
  );
}
